import { IFormErrors } from '@interfaces/IFormsErrors';
import { INote } from '@interfaces/INoteData';
import {
  IStudentFinalResults,
  IStudentGenerateFinalResults,
  IStudentResults,
} from '@interfaces/IStudentResults';
import { IUser, IUsersPagination } from '@interfaces/IUser';

export interface IUsersViewState {
  users: {
    listInfo: IUsersPagination | null;
    detail: IUser | null;
    isLoading: boolean;
    errors: IFormErrors | null;
  };
  students: {
    listInfo: IUsersPagination | null;
    detail: IUser | null;
    isLoading: boolean;
    errors: IFormErrors | null;
  };
  teachers: {
    listInfo: IUsersPagination | null;
    detail: IUser | null;
    isLoading: boolean;
    errors: IFormErrors | null;
  };
  notes: {
    listInfo: INote[];
    detail: INote | null;
    isLoading: boolean;
    errors: IFormErrors | null;
  };
  groupsResults: {
    results: IStudentResults[] | [];
    isLoading: boolean;
    errors: IFormErrors | null;
  };
  finalGenerateResults: {
    results: IStudentGenerateFinalResults | null;
    isLoading: boolean;
    errors: IFormErrors | null;
  };
  finalResults: {
    results: IStudentFinalResults[] | [];
    isLoading: boolean;
    errors: IFormErrors | null;
  };
}

export const initialsUsersViewState: IUsersViewState = {
  users: {
    listInfo: null,
    detail: null,
    isLoading: false,
    errors: null,
  },
  students: {
    listInfo: null,
    detail: null,
    isLoading: false,
    errors: null,
  },
  teachers: {
    listInfo: null,
    detail: null,
    isLoading: false,
    errors: null,
  },
  notes: {
    listInfo: [],
    detail: null,
    isLoading: false,
    errors: null,
  },
  groupsResults: {
    results: [],
    isLoading: false,
    errors: null,
  },
  finalGenerateResults: {
    results: null,
    isLoading: false,
    errors: null,
  },
  finalResults: {
    results: [],
    isLoading: false,
    errors: null,
  },
};
